import React from 'react';
import { IonModal, IonHeader, IonToolbar, IonTitle, IonSearchbar, IonContent, IonList, IonItem, IonLabel, IonButton } from '@ionic/react';
import './SearchSelectionModal.css';

interface SearchSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  searchQuery: string;
  filteredData: any[];
  onSearch: (e: CustomEvent) => void;
  onSelectItem: (item: any) => void;
}

const SearchSelectionModal: React.FC<SearchSelectionModalProps> = ({
  isOpen,
  onClose,
  searchQuery,
  filteredData,
  onSearch,
  onSelectItem
}) => {

  return (
    <IonModal
      isOpen={isOpen}
      initialBreakpoint={0.7}
      breakpoints={[1, 1, 1, 1]}
      onWillDismiss={onClose}
      trigger="open-custom-dialog"
      // style={{ overflowY: 'auto' }}
    >
      <IonHeader>
        <IonToolbar className="py-1">
          <IonButton
            fill="solid"
            slot="end"
            onClick={onClose}
            className="text-danger-500"
            color="danger"
            style={{
              backgroundColor: '#ef4444',
              border: '2px solid #dc2626',
              borderRadius: '8px',
            }}
          >
            إغلاق
          </IonButton>
          <IonTitle slot="center" className="my-2 text-primaryColor100">
            الرجاء الاختيار
          </IonTitle>
        </IonToolbar>
        <IonSearchbar
          placeholder="البحث"
          value={searchQuery}
          onIonInput={onSearch}
        />
      </IonHeader>
      <IonContent className="animate__animated animate__zoomInDown">
        <IonList className="p-2">
          {filteredData && filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <IonItem
                className="text-2xl text-primaryColor100"
                key={`${index}_${item.key}`}
                button
                onClick={() => onSelectItem(item)}
              >
                <IonLabel>{item.name}</IonLabel>
              </IonItem>
            ))
          ) : (
            <IonItem className="text-center">
              <IonLabel className="text-gray-500">
                لا توجد بيانات متاحة
              </IonLabel>
            </IonItem>
          )}
        </IonList>
      </IonContent>
    </IonModal>
  );
};

export default SearchSelectionModal;
